// extracted by mini-css-extract-plugin
export default {"button":"ExportJSONDataAsFile_button__P-ZDQ"};